import { useCallback, useEffect, useState } from "react"
import { useDebouncedCallback } from "use-debounce";

const DEFAULT_DURATION = 2000;

export default function useToast(props) {

  props = { duration: DEFAULT_DURATION, ...props };

  const [toastMessage, setToastMessage] = useState('');
  const [toastDuration, setToastDuration] = useState(props.duration);
  const [show, setShow] = useState(false);

  const hideSavedToast = useDebouncedCallback(() => {
    setShow(false);
  }, [toastDuration]);

  const showToast = useCallback((message, duration) => {
    hideSavedToast.cancel();
    // use current time in MS to allow resetting the toast on the useEffect (message count be the same, but toast should refresh):
    setShow(Date.now());
    setToastMessage(message);
    duration && setToastDuration(duration);
  }, [hideSavedToast]);

  useEffect(() => {
    if (show) {
      hideSavedToast();
    }
  }, [show, toastDuration, hideSavedToast])

  const hideToast = () => {
    hideSavedToast.flush();
  }

  const toast = {
    message: toastMessage,
    show: show !== false,
  }

  return {
    toast,
    showToast,
    hideToast
  }
}
